<script setup>
import { useVModel } from '@vueuse/core';

const props = defineProps({
  // Hay problemas con los timezones cuando usamos objetos date así que hemos decidido que
  // vamos a utilizar un String con el formato ISO y solo la fecha: 2023-09-14
  fechaInicio: { type: String, default: null },
  fechaFin: { type: String, default: null },
  readonly: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  autoClose: { type: Boolean, default: null },
  nameFechaInicio: { type: String, default: null },
  nameFechaFin: { type: String, default: null },
});

const emits = defineEmits(['update:fechaInicio', 'update:fechaFin']);

const fechaInicioInterna = useVModel(props, 'fechaInicio', emits);
const fechaFinInterna = useVModel(props, 'fechaFin', emits);

</script>
<template>
  <div class="datepicker-range">
    <div class="input-group">
      <InputFechaHora
        v-model="fechaInicioInterna"
        :name="nameFechaInicio"
        :icon="false"
        :disabled="disabled"
        :readonly="readonly"
        :auto-close="autoClose"
        position="bottom left"
        :form-group="false"
      />
      <span class="input-group-addon"><i class="far fa-arrows-h"></i></span>
      <InputFechaHora
        v-model="fechaFinInterna"
        :name="nameFechaFin"
        :icon="false"
        :disabled="disabled"
        :readonly="readonly"
        :auto-close="autoClose"
        position="bottom right"
        :form-group="false"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
